var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-system-bar',{attrs:{"app":""}},[_c('span',[_vm._v(" V"+_vm._s(_vm.$version)+" ")]),_c('v-spacer'),_c('span',[_c('strong',[_vm._v(_vm._s(_vm.nowTime))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }